import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {

  connect() {
    this.initTooltips()
    this.observer = new MutationObserver(() => this.initTooltips())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  initTooltips() {
    const triggers = this.element.querySelectorAll('[data-bs-toggle="tooltip"]')
    triggers.forEach((el) => {
      if (bootstrap.Tooltip.getInstance(el)) return
      new bootstrap.Tooltip(el, {
        trigger: 'hover',
        html: true,
        boundary: 'window',
        container: 'body'
      })
    })
  }
}
